/* unplugin-vue-components disabled */import { render } from "./ShopMatterSettingView.vue?vue&type=template&id=67865ca8&scoped=true"
import script from "./ShopMatterSettingView.vue?vue&type=script&lang=js"
export * from "./ShopMatterSettingView.vue?vue&type=script&lang=js"

import "./ShopMatterSettingView.vue?vue&type=style&index=0&id=67865ca8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67865ca8"]])

export default __exports__